var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRobust(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 66,
    viewBox: "0 0 69 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9_169",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 69,
    height: 66
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 66,
    rx: 5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7458 57.75C7.85075 57.75 5.45146 53.4932 7.46835 50.161L30.2225 12.5672C32.1682 9.35252 36.8318 9.35252 38.7775 12.5672L61.5317 50.161C63.5485 53.4933 61.1493 57.75 57.2542 57.75H11.7458ZM17.4052 44.655C15.382 47.9871 17.7808 52.25 21.6791 52.25H47.3209C51.2192 52.25 53.618 47.9871 51.5948 44.655L38.7739 23.5391C36.8269 20.3323 32.1731 20.3324 30.2261 23.5391L17.4052 44.655ZM34.5 49.5C35.3146 49.5 35.9974 49.2365 36.5484 48.7094C37.0995 48.1823 37.375 47.5292 37.375 46.75C37.375 45.9708 37.0995 45.3177 36.5484 44.7906C35.9974 44.2635 35.3146 44 34.5 44C33.6854 44 33.0026 44.2635 32.4516 44.7906C31.9005 45.3177 31.625 45.9708 31.625 46.75C31.625 47.5292 31.9005 48.1823 32.4516 48.7094C33.0026 49.2365 33.6854 49.5 34.5 49.5ZM31.625 38.375C31.625 39.9628 32.9122 41.25 34.5 41.25C36.0878 41.25 37.375 39.9628 37.375 38.375V30.375C37.375 28.7872 36.0878 27.5 34.5 27.5C32.9122 27.5 31.625 28.7872 31.625 30.375V38.375Z",
    fill: "#014AAA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobust);
export default __webpack_public_path__ + "static/media/robust.2808b93a8d3aeded776988350de1c0bf.svg";
export { ForwardRef as ReactComponent };